import { removeUnderScoreWithUpperCase } from "../../../utils/removeUnderscore";

export type OrderTimelineEntry = {
  scope?: string;
  from?: string | null;
  to?: string;
  userId?: string;
  supplierId?: string;
  at?: string | Date;
};

export type AuditTrailStage = {
  scope?: string;
  status: string | null;
  at?: string | Date | null;
  userId?: string | null;
  supplierId?: string | null;
  /** Created row has no previous stage. */
  diffFromPrevious?: "-";
};

export const formatTimelineStatus = (status?: string | null) => {
  if (!status) return null;
  const leaf = status.includes(".") ? status.split(".").pop() : status;
  return removeUnderScoreWithUpperCase(leaf ?? status);
};

/**
 * One row per entered state (`to`). The order's starting state is the first
 * event's `from`, shown at createdAt with no user.
 */
export function buildAuditTrailStages(
  entries: OrderTimelineEntry[],
  createdAt?: string | Date | null,
): AuditTrailStage[] {
  if (!entries.length) return [];

  const stages: AuditTrailStage[] = [];
  const startedAs = entries[0].from;
  if (formatTimelineStatus(startedAs)) {
    stages.push({
      scope: entries[0].scope,
      status: startedAs ?? null,
      at: createdAt ?? null,
      userId: null,
      supplierId: null,
      diffFromPrevious: "-",
    });
  }

  entries.forEach((entry, idx) => {
    const isCreatedTo = !formatTimelineStatus(startedAs) && idx === 0;
    stages.push({
      scope: entry.scope,
      status: entry.to ?? null,
      at: isCreatedTo ? (createdAt ?? entry.at ?? null) : entry.at,
      userId: isCreatedTo ? null : entry.userId,
      supplierId: isCreatedTo ? null : entry.supplierId,
      ...(isCreatedTo ? { diffFromPrevious: "-" as const } : {}),
    });
  });

  return stages;
}
